import React from 'react';
import { StyledSVG } from '@common/styles';
import { ProductStatus as ProductStatusType } from '@common/features/submission/types';

export interface IProductStatus {
  value: ProductStatusType;
  isWithDatapharm?: boolean;
}

const ProductStatus = ({ value, isWithDatapharm }: IProductStatus) => {
  const renderStatus = () => {
    if (isWithDatapharm) {
      return <StyledSVG height={25} src="/icons/with_datapharm_tag.svg" data-testid="with-datapharm-label" />;
    }

    switch (value) {
      case ProductStatusType.Published:
        return <StyledSVG height={25} src="/icons/published_tag.svg" data-testid="published-label" />;
      case ProductStatusType.Submitted:
        return <StyledSVG height={25} src="/icons/submitted_tag.svg" data-testid="submitted-label" />;
      case ProductStatusType.Discontinued:
        return <StyledSVG height={25} src="/icons/discontinued_tag.svg" data-testid="discontinued-label" />;
      case ProductStatusType.Retired:
        return <StyledSVG height={25} src="/icons/retired_tag.svg" data-testid="retired-label" />;
      default:
        return <StyledSVG height={25} src="/icons/draft_tag.svg" data-testid="draft-label" />;
    }
  };

  return renderStatus();
};

export default ProductStatus;
